module.exports = __webpack_public_path__ + "static/img/icon-nodata.e515a943.png";